import gql from 'graphql-tag';

export default gql`
  fragment seatPlanFragment on FlightSeatmap {
    colsMap
    seatSizesMap {
      id
      name
      legroomStars
    }
    rows {
      id
      hasLeftExit
      hasRightExit
      items {
        ... on FlightSeat {
          type
          id
          price {
            amount
            currency
          }
          seatPrice {
            subtotal
            taxes {
              breakdown {
                name
                code
                value {
                  amount
                }
              }
              total {
                amount
                currency
              }
            }
            taxesIncludedInBundle {
              breakdown {
                name
                code
                value {
                  amount
                }
              }
              total {
                amount
                currency
              }
            }
            total
            isUpgradePrice
          }
          position
          sizeId
          isAvailable
          isExitRow
          isWindowless
          isIncludedInBundle
        }
        ... on FlightRowBlank {
          type
        }
        ... on FlightRowAisle {
          type
        }
      }
    }
  }
`;
